import { isEqual, map, isNumber, isBoolean, find, isString } from 'lodash';
import Vue from 'vue';
import debug from 'debug';
import VueRouter from 'vue-router';
const log = debug('itp:core:routes');
const __specs__ = [];
export function addRoute(config) {
    log('addRoute: %o', config);
    __specs__.push(config);
}
export function getRouter(home) {
    const router = new VueRouter();
    const specs = __specs__;
    const redirect = getDefaultRoute(specs);
    log('default redirect to "%s"', redirect);
    const defaultRoute = {
        path: '',
        component: Vue.component(home)
    };
    defaultRoute.children = buildRoutes(defaultRoute, specs);
    router.addRoute(defaultRoute);
    router.beforeEach((to, from, next) => {
        next();
    });
    return router;
}
const getDefaultRoute = (specs) => {
    for (let r of specs) {
        if (r.default) {
            return r.name;
        }
    }
};
const buildRoutes = (parent, specs) => {
    return map(findChildren(parent.name, specs), spec => buildRouteConfig(parent, spec, specs));
};
const buildRouteConfig = (parent, spec, all) => {
    const routeName = `app.${spec.name}`;
    log('create route ' +
        `(name=${routeName}, path=${spec.path}, component=${spec.component})`);
    const result = {
        path: spec.path,
        name: `app.${spec.name}`,
        component: Vue.component(spec.component),
        props: componentPropsGetter(spec),
        meta: {
            title: '..',
            key: getTabKey(spec, all)
        }
    };
    log('create route result=%o', result);
    result.children = buildRoutes(result, all);
    return result;
};
const componentPropsGetter = (spec) => {
    return function getProps(route) {
        log('getProps [%s]', spec.name);
        if (spec.params) {
            log('params:', spec.params);
        }
        log('route:', route);
        const result = { ...route.params };
        if (spec.params) {
            for (const p of spec.params) {
                if (p.name in route.params) {
                    result[p.prop] = route.params[p.name];
                    continue;
                }
                if (p.name in route.query) {
                    const value = route.query[p.name];
                    if (isString(value) || isNumber(value) || isBoolean(value)) {
                        result[p.prop] = value.toString();
                    }
                    continue;
                }
                console.warn(`Cannot resolve component prop "${p.prop}": missing route param "${p.name}"`);
            }
        }
        if (spec.componentProps) {
            for (let item of spec.componentProps) {
                result[item.name] = item.value;
            }
        }
        log('result: %o', result);
        return result;
    };
};
const getTabKey = (spec, all) => {
    const parts = spec.name.split('.');
    log('getTabKey parts: %o', parts);
    if (parts.length > 1) {
        const p0 = parts[0], parent = find(all, p => p.name === p0);
        if (!parent) {
            throw new Error(`cannot find parent route "${p0}"`);
        }
        const parentPath = parent.path;
        log('getTabKey will return parent path %s', parentPath);
        return parentPath;
    }
    return 'path';
};
const findChildren = (name, specs) => {
    if (name == null) {
        return specs.filter(p => p.name.indexOf('.') === -1);
    }
    const parts = name.split('.');
    return specs.filter(p => {
        if (p.name.indexOf('.') === -1) {
            return false;
        }
        const thisParts = `app.${p.name}`.split('.');
        if (thisParts.length - 1 !== parts.length) {
            return false;
        }
        return isEqual(parts, thisParts.slice(0, thisParts.length - 1));
    });
};
//# sourceMappingURL=routes.js.map